import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { classNames, NumberDisplay } from "@opensea/ui-kit";
import { rarityVariants } from "../rarity/constants";
import { ActivityRarityFragment } from "./ActivityRarity.fragment";
export function ActivityRarity(t0) {
  const $ = _c(9);
  const {
    item: itemKey,
    className
  } = t0;
  let T0;
  let item;
  let t1;
  if ($[0] !== className || $[1] !== itemKey) {
    item = readFragment(ActivityRarityFragment, itemKey);
    T0 = NumberDisplay;
    t1 = classNames(rarityVariants({
      variant: item.rarity?.category ?? "NONE"
    }).text(), className);
    $[0] = className;
    $[1] = itemKey;
    $[2] = T0;
    $[3] = item;
    $[4] = t1;
  } else {
    T0 = $[2];
    item = $[3];
    t1 = $[4];
  }
  const t2 = item.rarity?.rank;
  let t3;
  if ($[5] !== T0 || $[6] !== t1 || $[7] !== t2) {
    t3 = <T0 className={t1} display="full" prefix="#" value={t2} />;
    $[5] = T0;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}